import { forwardRef } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Autocomplete } from '~/components/autocomplete/Autocomplete';
import { SlideUpIn } from '../chat/SlideUpIn';

interface AddressStepProps {
  placeName: string;
  address: unknown;
  onAddressChange: (result: unknown) => void;
  onNext: () => void;
  onSkip: () => void;
  onBack?: () => void;
  isSubmitting: boolean;
  isFadingOut: boolean;
  onFocus?: () => void;
}

export const AddressStep = forwardRef<HTMLDivElement, AddressStepProps>(
  function AddressStep(
    {
      placeName,
      address,
      onAddressChange,
      onNext,
      onSkip,
      onBack,
      isSubmitting,
      isFadingOut,
      onFocus,
    },
    ref
  ) {
    return (
      <SlideUpIn fadeOut={isFadingOut}>
        <div
          ref={ref}
          onFocusCapture={onFocus}
          className='mx-auto mb-24 max-w-xl rounded-2xl border border-grey-20 bg-white p-6 shadow-sm'
        >
          <div className='text-brand-700 mx-auto mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-[#23808010]'>
            <FontAwesomeIcon
              className='h-5 w-5 text-primary-container'
              icon={faLocationDot as IconProp}
            />
          </div>
          <div className='mb-1 text-center text-lg font-semibold'>
            Add Address
          </div>
          <div className='text-grey-60 mb-4 text-center text-sm'>
            Enter the complete address for &quot;{placeName}&quot;.
          </div>
          <div>
            <Autocomplete
              label=''
              onGeocoded={(result) => {
                onAddressChange(result);
              }}
            />
          </div>

          <div className='mt-3 flex flex-col justify-end gap-2'>
            <button
              type='button'
              className='rounded-md bg-brand px-4 py-2.5 text-white hover:bg-brand-dark disabled:opacity-50'
              disabled={!address || isSubmitting}
              onClick={onNext}
            >
              Next
            </button>
            <div className='flex items-center justify-between'>
              {onBack ? (
                <button
                  type='button'
                  className='text-sm text-grey-50 hover:text-grey-70 disabled:opacity-50'
                  disabled={isSubmitting}
                  onClick={onBack}
                  aria-label='Go back to place type selection'
                >
                  ← Back
                </button>
              ) : (
                <div />
              )}
              <button
                type='button'
                className='text-grey-80 rounded-md px-4 py-2.5 underline hover:text-black disabled:opacity-50'
                disabled={isSubmitting}
                onClick={onSkip}
              >
                Skip
              </button>
            </div>
          </div>
        </div>
      </SlideUpIn>
    );
  }
);
